import {useState} from "react";
import {Box, Collapse, IconButton, Paper, Stack, Typography} from "@mui/material";
import {IconChevronDown, IconChevronRight} from "@tabler/icons-react";
import {grey} from "@mui/material/colors";


export const TemplateAccordion = ({title, description, children}) => {
  const [open, setOpen] = useState(true);

  return (
    <>
      <Stack direction={"row"} gap={2} alignItems={"center"}>
        <Box>
          <IconButton onClick={() => setOpen(!open)}>
            {open ? <IconChevronDown size={20} /> : <IconChevronRight size={20} />}
          </IconButton>
        </Box>
        <Box>
          <Typography variant={"h4"} fontWeight={600} align={"left"} guuterBottom>{title}</Typography>
          <Typography variant={"body2"} align={"left"} color={grey[400]} sx={{textAlign: "left !important"}}>{description}</Typography>
        </Box>
      </Stack>
      <Collapse in={open}>
        {children}
      </Collapse>
    </>
  )
}